import {ListView} from '@github-ui/list-view'
import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {ListItemDescriptionItem} from '@github-ui/list-view/ListItemDescriptionItem'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import {ListItemTitleV2} from '@github-ui/list-view/ListItemTitleV2'
import {Box} from '@primer/react'
import type {ReactElement} from 'react'

import styles from './AttestationPropertiesList.module.css'

interface PropertyDefinition {
  propertyName: string
  propertyValue: ReactElement
}

interface Props {
  definitions: PropertyDefinition[]
}

export function AttestationPropertiesList({definitions}: Props) {
  return (
    <Box data-hpc sx={{border: '1px solid', borderColor: 'border.muted', borderRadius: 2}}>
      <ListView title="Attestation summary" variant="compact">
        {definitions.map(definition => (
          <ListItem
            key={definition.propertyName}
            title={
              <ListItemTitleV2
                value={definition.propertyName}
                headingClassName={styles.ListItemTitle_0}
                containerClassName={styles.ListItemTitle_1}
              />
            }
            className={styles.ListItem_0}
          >
            <ListItemMainContent>
              <ListItemDescription className={styles.ListItemDescription_0}>
                <ListItemDescriptionItem className={styles.ListItemDescriptionItem_0}>
                  {definition.propertyValue}
                </ListItemDescriptionItem>
              </ListItemDescription>
            </ListItemMainContent>
          </ListItem>
        ))}
      </ListView>
    </Box>
  )
}

try{ AttestationPropertiesList.displayName ||= 'AttestationPropertiesList' } catch {}